<template>
  <div class="page flex flex-col mh100">
    <el-form>
      <el-form-item>
        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </el-form-item>
    </el-form>
    <div class="flex-1 overA">
      <el-table :data="menuList" highlight-current-row v-loading="tableLoading" @current-change="selectCurrentRow"
        row-key="id" border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        style="width: 100%;">
        <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
        <el-table-column prop="name" label="区域名称" min-width="200"></el-table-column>
        <el-table-column prop="order" label="排序" min-width="50"></el-table-column>
        <el-table-column prop="isActive" label="是否启用" min-width="50">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'danger'" disable-transitions>{{ scope.row.isActive ?
                "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          style="float: right"
          :total="total"
          :current-page="pageIndex"
          :pageSize="pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination> -->
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="menuFormVisible" v-if="menuFormVisible"
      v-model="menuFormVisible" :close-on-click-modal="false">
      <el-form :model="menuForm" label-width="120px" :rules="menuFormRules" ref="menuForm">
        <el-form-item label="区域名称" prop="name">
          <el-input v-model="menuForm.name" auto-complete="off" placeholder="请输入区域名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input v-model="menuForm.order" auto-complete="off" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="父级" prop="pidArr">
          <el-cascader :placeholder="placeholder" ref="cascaderCategory" filterable change-on-select style="width: 100%"
            v-model="menuForm.pidArr" :props="props"></el-cascader>
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-select v-model="menuForm.isActive" placeholder="请选择状态">
            <el-option label="激活" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="menuFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitArea" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAreaTree,
  CreateArea,
  GetAreaDetail,
  UpdateArea,
  DeleteArea,
  GetAllArea
} from "../../../api/api";
import toolbar from "../../../components/Toolbar";
import { getButtonList } from "../../../promissionRouter";
export default {
  components: { toolbar },
  data() {
    let that = this;
    return {
      // 级联选择器懒加载
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          that.renderArea(resolve, node.level, node);
        },
      },
      buttonList_toolBar: [],

      menuList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      pageIndex: 1,
      pageSize: 10,

      menuFormVisible: false,
      isEdit: false,
      menuForm: {
        name: null,
        parentId: null,
        pidArr: null,
        order: null,
        isActive: true
      },
      menuFormRules: {
        name: [
          { required: true, message: '请输入区域名称', trigger: 'blur' },
          { message: '请输入区域名称', trigger: ['blur', 'change'] }
        ],
        order: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { message: '请输入排序', trigger: ['blur', 'change'] }
        ],
        pidArr: [
          { type: 'array', required: true, message: '请选择父级', trigger: 'change' }
        ],
      },
      menuTreeList: [],
      submitLoading: false,
      placeholder: '请选择'
    };
  },
  mounted() {
    this.getAreaList();
    this.renderButton();
  },
  methods: {
    renderArea(resolve, level, node) {
      let params = {
        SkipCount: 0,
        MaxResultCount: 1000
      };
      if (level == 0) {
        resolve([{ id: 0, label: '根节点', leaf: false, value: 0 }]);
      } else {
        params.ParentId = node.data.id;
        GetAllArea(params).then((res) => {
          let arr = res.data.result.items.map((e) => ({ id: e.id, value: e.id, label: e.name, leaf: level >= 3 }));
          resolve(arr);
        });
      }
    },
    renderButton() {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getAreaList() {
      let para = { ParentId: 0, SkipCount: 0, MaxResultCount: 200 };
      this.tableLoading = true;
      GetAllArea(para).then((res) => {
        this.tableLoading = false;
        this.total = res.data.result.totalCount;
        let data = res.data.result.items;
        data.forEach(x => {
          x.hasChildren = true
        });
        this.menuList = data;
      });
    },
    // 懒加载菜单
    load(tree, treeNode, resolve) {
      let params = { ParentId: tree.id, SkipCount: 0, MaxResultCount: 50 };
      GetAllArea(params).then((res) => {
        let data = res.data.result.items;
        data.forEach(x => {
          if (x.level < 4) {
            [
              x.hasChildren = true
            ]
          }
        });
        resolve(data);
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getAreaList();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getAreaList();
    },
    create() {
      this.menuFormVisible = true;
      this.isEdit = false;
      this.menuForm = {
        name: null,
        parentId: null,
        pidArr: null,
        order: null,
        isActive: true
      };
      this.placeholder = '请选择';
    },
    getAreaTreeList() {
      let params = {
        MaxLevel: 3
      };
      GetAreaTree(params).then((res) => {
        this.menuTreeList = this.loopTree([res.data.result]);
      });
    },
    loopTree(treeList) {
      const newList = treeList.filter(item => {
        if (!item.data.Id) {
          item.value = 0 + '',
            item.label = '根节点'
        } else {
          item.value = item.data.Id + '';
          item.label = item.data.DisplayName;
        }
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopTree(item.children)
        }
        return true;
      })
      return newList;
    },
    edit() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      GetAreaDetail(params).then((res) => {
        if (res.data.success) {
          this.isEdit = true;
          this.menuFormVisible = true;
          let data = res.data.result;
          this.menuForm = {
            name: data.name,
            parentId: data.parentId,
            order: '' + data.order,
            isActive: true,
            pidArr: null,
            id: data.id
          };
          let level = data.level;
          if (level == 1) {
            this.placeholder = '根节点';
            this.menuForm.pidArr = [0];
          }
          if (level == 2) {
            let params = { Id: row.parentId };
            GetAreaDetail(params).then((res) => {
              this.placeholder = '根节点 / ' + res.data.result.name;
              this.menuForm.pidArr = [0, res.data.result.id];
            })
          }
          if (level == 3) {
            let params1 = { Id: row.parentId };
            GetAreaDetail(params1).then((res1) => {
              let params2 = { Id: res1.data.result.parentId };
              GetAreaDetail(params2).then((res2) => {
                this.placeholder = '根节点 / ' + res2.data.result.name + ' / ' + res1.data.result.name;
                this.menuForm.pidArr = [0, res2.data.result.id, res1.data.result.id];
              })
            })
          }
          if (level == 4) {
            let params1 = { Id: row.parentId };
            GetAreaDetail(params1).then((res1) => {
              let params2 = { Id: res1.data.result.parentId };
              GetAreaDetail(params2).then((res2) => {
                let params3 = { Id: res2.data.result.parentId };
                GetAreaDetail(params3).then((res3) => {
                  this.placeholder = '根节点 / ' + res3.data.result.name + ' / ' + res2.data.result.name + ' / ' + res1.data.result.name;
                  this.menuForm.pidArr = [0, res3.data.result.id, res2.data.result.id, res1.data.result.id];
                })
              })
            })
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    del() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        DeleteArea(params).then((res) => {
          this.tableLoading = false;
          if (res.data.success) {
            this.$message.success('删除成功');
            this.getAreaList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => { });
    },
    submitArea() {
      this.$refs.menuForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            this.submitLoading = true;
            this.menuForm.parentId = this.menuForm.pidArr[this.menuForm.pidArr.length - 1];
            if (!this.isEdit) {
              CreateArea(this.menuForm).then((res) => {
                this.submitLoading = false;
                if (res.data.success) {
                  this.$message.success('新增成功');
                  this.menuFormVisible = false;
                  this.getAreaList();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateArea(this.menuForm).then((res) => {
                this.submitLoading = false;
                if (res.data.success) {
                  this.$message.success('修改成功');
                  this.menuFormVisible = false;
                  this.getAreaList();
                } else {
                  this.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => { });
        }
      });
    }
  }
};
</script>
<style scoped>
</style>
